import { http } from './http';
import { ROUTES } from './config';
import type { LoyaltyMember, LoyaltyTier, LoyaltyTierInput, MyLoyaltyStatus } from '../types/ecommerce';

/**
 * CrmService's loyalty program client. Tier reads are public (storefront "join and save"
 * pitch); me/enroll are customer-authenticated; tier CRUD and the member list are manager+,
 * enforced in-service via [RequireRoles] — same "gateway lets it through, the controller
 * gates it" split as productsApi.
 */
export const loyaltyApi = {
  listTiers(): Promise<LoyaltyTier[]> {
    return http.get(`${ROUTES.loyalty}/tiers`, { anonymous: true });
  },

  createTier(body: LoyaltyTierInput): Promise<LoyaltyTier> {
    return http.post(`${ROUTES.loyalty}/tiers`, body);
  },

  updateTier(id: string, body: LoyaltyTierInput): Promise<void> {
    return http.put(`${ROUTES.loyalty}/tiers/${id}`, body);
  },

  removeTier(id: string): Promise<void> {
    return http.delete(`${ROUTES.loyalty}/tiers/${id}`);
  },

  me(): Promise<MyLoyaltyStatus> {
    return http.get(`${ROUTES.loyalty}/me`);
  },

  enroll(): Promise<MyLoyaltyStatus> {
    return http.post(`${ROUTES.loyalty}/enroll`);
  },

  listMembers(): Promise<LoyaltyMember[]> {
    return http.get(`${ROUTES.loyalty}/members`);
  },
};
